import styled from 'styled-components';
import { pxToRem, Card, Inline, Stack } from 'src/viewLayer/components/DesignSystem';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';
import devices from 'src/viewLayer/styling/mixins/media-queries';

export const QuestionNodeContainer = styled(Stack)`
  gap: ${tokens.size.space.large};
  margin: ${tokens.size.space.large} ${tokens.size.space.small};
  max-width: ${pxToRem(328)};
  min-height: calc(100vh - 270px);
  min-width: ${pxToRem(300)};

  @media ${devices.fromxsmall} {
    max-width: ${pxToRem(500)};
    min-width: ${pxToRem(400)};
  }
  @media ${devices.fromsmall} {
    max-width: ${pxToRem(700)};
  }
  @media ${devices.frommedium} {
    gap: ${tokens.size.space.xlarge};
    margin: ${tokens.size.space.xxlarge} ${tokens.size.space.small};
  }
`;

export const AnswersListContainer = styled(Stack)`
  width: 100%;
  align: left;
  @media ${devices.fromxsmall} {
    min-width: ${pxToRem(328)};
  }
  @media ${devices.fromsmall} {
    background-color: none;
    gap: 1rem;
    max-width: ${pxToRem(448)};
  }
`;

export const AnswerCard = styled(Card)`
  background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.enabled};
  border: 1px solid ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.enabledBorderSubdued};
  border-radius: ${tokens.size.radius.large};
  box-shadow: 0 0 1.25rem ${tokens.boxShadow.card};
  cursor: pointer;
  min-height: unset;
  padding: 1rem;
  @media (hover) {
    &:hover {
    background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.hover};
    }
    &:focus {
    background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.hover};
    }
    &:active {
    background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.hover};
    }
  }
`;
export const AnswerContainer = styled(Inline)`
  cursor: pointer;
  width: 100%;
`;

export const TitleContainer = styled(Stack)`
  margin: 0;
  text-align: left;
  @media ${devices.fromxsmall} { text-align: center; }
`;

export const Tagline = styled(Stack)`
  margin: 0;
  text-align: left;
  @media ${devices.fromxsmall} { text-align: center; }
`;
